import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { FaChevronDown } from 'react-icons/fa';

const ReusableSelect = ({ 
    label, 
    value, 
    onChange, 
    placeholder, 
    error, 
    icon, 
    name, 
    required,
    options 
}) => {
    return (
        <Form.Group className="mb-4">
            <Form.Label className="input-label">
                {label} {required && <span className="text-danger">*</span>}
            </Form.Label>
            <div className="input-wrapper">
                <Form.Select
                    className="reusable-select"
                    value={value}
                    onChange={onChange}
                    name={name}
                    // style={{
                    //     border: error ? "1px solid red" : "1px solid #ced4da",
                    //     padding: "15px 15px",
                    //     borderRadius: "10px",
                    // }}
                >
                    <option value="" disabled>
                        {placeholder || 'Select an option'}
                    </option>
                    {options.map((option, index) => (
                        <option key={index} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </Form.Select>
            </div>
            {/* Only show error feedback if there is an error */}
            {error && (
                <div
                    style={{
                        width: "100%",
                        margin: "0px",
                        padding: "0px",
                        display: "flex",
                        position: "relative",
                    }}
                >
                    <span 
                        style={{
                            fontSize: ".8rem",
                            color: "red", 
                            position: "absolute", 
                            bottom: "-17px", 
                            left: "0px"
                        }}
                    >
                        {error}
                    </span>
                </div>
            )}
        </Form.Group>
    );
};

ReusableSelect.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    icon: PropTypes.element,
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired
};

ReusableSelect.defaultProps = {
    placeholder: 'Select an option',
    error: '',
    icon: <FaChevronDown />,
    required: false
};

export default ReusableSelect;